import { render } from "./UnitListPage.vue?vue&type=template&id=9a7af67c&scoped=true&ts=true"
import script from "./UnitListPage.vue?vue&type=script&lang=ts"
export * from "./UnitListPage.vue?vue&type=script&lang=ts"

import "./UnitListPage.vue?vue&type=style&index=0&id=9a7af67c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7af67c"]])

export default __exports__